<template>
  <v-dialog v-model="isOpen" max-width="520" persistent>
    <v-card>
      <v-card-title>{{ $t("employee.bulk.roleTitle") }}</v-card-title>

      <v-card-text>
        <div class="mb-4 body-2">
          {{ $t("employee.bulk.roleSubtitle", { count: employeeIds.length }) }}
        </div>
        <v-select
          v-model="selectedRole"
          :items="roleItems"
          item-text="label"
          item-value="key"
          :label="$t('employee.bulk.roleSelect')"
          dense
          outlined
          hide-details
        ></v-select>

        <v-menu
          v-if="showDate"
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="mt-4"
              v-model="dueDate"
              :label="$t('employee.bulk.roleDueDate')"
              prepend-inner-icon="mdi-calendar"
              readonly
              clearable
              dense
              outlined
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dueDate"
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close" :disabled="loading">
          {{ $t("general.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!selectedRole"
          @click="apply"
        >
          {{ $t("general.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const BUILT_IN_ROLES = [
  { key: "safetyOfficer", label: "employee.safetyOfficer", showDate: false },
  { key: "fireMarshal", label: "employee.fireMarshal", showDate: true },
  { key: "firstAider", label: "employee.firstAider", showDate: true },
];

export default {
  name: "EmployeeBulkRoleDialog",
  data() {
    return {
      isOpen: false,
      loading: false,
      dateMenu: false,
      employeeIds: [],
      selectedRole: null,
      dueDate: null,
    };
  },
  computed: {
    customRoleDefs() {
      return this.$store.getters.employeeRoleDefinitions || [];
    },
    roleItems() {
      const builtIn = BUILT_IN_ROLES.map((r) => ({
        key: r.key,
        label: this.$t(r.label),
        showDate: r.showDate,
      }));
      const custom = this.customRoleDefs.map((d) => ({
        key: d._id,
        label: d.name,
        showDate: true,
      }));
      return [...builtIn, ...custom];
    },
    showDate() {
      const found = this.roleItems.find((r) => r.key === this.selectedRole);
      return found ? found.showDate : false;
    },
  },
  methods: {
    open(employees) {
      this.employeeIds = (employees || []).map((e) => e._id);
      this.selectedRole = null;
      this.dueDate = null;
      this.isOpen = true;
      this.$store.dispatch("getEmployeeRoleDefinitions");
    },
    close() {
      this.isOpen = false;
    },
    async apply() {
      if (!this.selectedRole) return;
      this.loading = true;
      try {
        await this.$store.dispatch("bulkAssignRole", {
          ids: this.employeeIds,
          role: this.selectedRole,
          dueDate: this.dueDate || null,
        });
        this.isOpen = false;
        this.$emit("applied");
      } catch (e) {
        // error snackbar handled in store action
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
